export default function findInStringCaseInsensitive({ text, sample }) {
  return text.toLowerCase().includes(sample.toLowerCase());
}
